import { Layout } from "../Layout/Layout";
import homeStyle from "./Home.module.scss";
import { Button } from "../../components/Button/Button";
import React from 'react';
import { endpoints } from "../../../utils/endpoints";
import foxbelIcon from "../../../assets/images/musicaklive.png";
import foxbelPic from "../../../assets/images/musicaklive.png";
import { SadFaceSVG } from "../../components/SVG/SadFace";
import { LoadOverlay } from "../LoadOverlay/LoadOverlay";
import jsonp from "jsonp";
const { useEffect, useState } = React;

type trackListType = {
    title: string,
    cover: string,
    tracks: Array<any>
}

export const Home = () => {
    const [albums, setAlbums] = useState<any[]>([]);
    const [trackList, setTrackList] = useState<trackListType>({ title: "", cover: "", tracks: [] });
    const [firstTrack, setFirstTrack] = useState<any>();
    const [search, setSearch] = useState<string>("");
    const [artistFollowers, setArtistFollowers] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        jsonp(endpoints.musicWithoutProxy + "/search/album?q=a&output=jsonp", (err, resp) => {
            if (err) console.log(err)
            else setAlbums(resp.data);
        })
    }, []);

    useEffect(() => {
        if (!albums[0]) return;
        jsonp(albums[0].tracklist + "?output=jsonp", (err, resp) => {
            if (err) console.log(err)
            else setFirstTrack(resp.data[0])
        })
    }, [albums])

    useEffect(() => {
        if (!firstTrack) return;
        jsonp(endpoints.musicWithoutProxy + "/artist/" + firstTrack.artist.id + "?output=jsonp", (err, resp) => {
            if (err) console.log(err)
            else {
                setArtistFollowers(resp.nb_fan);
                setLoading(false);
            }
        })
    }, [firstTrack])

    const getTrackList = (tracklistLink: string, albumTitle: string, cover: string, artistId: string) => {
        jsonp(tracklistLink + "?output=jsonp", (err, resp) => {
            if (err) console.log(err)
            else setTrackList({ title: albumTitle, cover, tracks: resp.data });
        })
    }

    const searchTracks = (e: any) => {
        if (search === "") return;
        if (e.key !== "Enter") return;
        setLoading(true);
        jsonp(endpoints.musicWithoutProxy + "/search/album?q=" + search + "&output=jsonp", (err, resp) => {
            if (err) console.log(err)
            else {
                if (resp.data.length < 1) setLoading(false);
                setAlbums(resp.data);
            }
        })
    }

    const onChangeSearch = (e: any) => {
        setSearch(e.target.value);
    }

    return (
        <>
            <Layout trackList={trackList.tracks} albumTitle={trackList.title} cover={trackList.cover} >
                <div className={`${homeStyle.main}`}>
                    <header>
                        <div className={homeStyle.search}>
                            <div className={homeStyle.searchBlock}>
                                <input
                                    type="text"
                                    className={homeStyle.searchBar}
                                    onChange={onChangeSearch}
                                    onKeyPress={searchTracks}
                                    value={search}
                                    placeholder="Buscar" />
                                <i onClick={() => searchTracks({ key: "Enter" })} className="fas fa-search"></i>
                            </div>
                        </div>
                    </header>
                    <LoadOverlay loading={loading}>
                        {
                            albums.length > 0 ?
                                <>
                                    <section className={homeStyle.featured}>
                                        <div className={homeStyle.cover}>
                                            <img src={albums[0] ? albums[0].cover_big : foxbelIcon} alt="featured-album-cover" />
                                            <i
                                                onClick={() => getTrackList(albums[0].tracklist, albums[0].title, albums[0].cover_medium, albums[0].artist.id)}
                                                className={`fas fa-play ${homeStyle.play}`}>
                                            </i>
                                        </div>
                                        <div className={homeStyle.info}>
                                            <img src={albums[0] ? albums[0].artist.picture_big : foxbelPic} alt="second-cover-background" />
                                            <div className={homeStyle.details}>
                                                <h2>{firstTrack ? firstTrack.title : "Foxbel Music"}</h2>
                                                <span>
                                                    <h3>Lo mejor de {albums[0] ? albums[0].artist.name : "Foxbel Music"}</h3>
                                                    <p>{artistFollowers ? artistFollowers : "---"} seguidores</p>
                                                </span>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                                <div className={homeStyle.buttons}>
                                                    <Button>Reproducir</Button>
                                                    <Button variant="outlined">Seguir</Button>
                                                    <i className="fas fa-ellipsis-h"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    <h3>Resultados</h3>
                                    <div className={homeStyle.results}>
                                        {
                                            albums.map((album: any) => (
                                                <div key={album.id} className={homeStyle.resultItem}>
                                                    <div className={homeStyle.resultCover}>
                                                        <img src={album['cover_medium']} alt="cover" />
                                                        <i className={`fas fa-ellipsis-v ${homeStyle.ellipsis}`}></i>
                                                        <i
                                                            onClick={() => getTrackList(album.tracklist, album.title, album.cover_medium, album.artist.id)}
                                                            className={`fas fa-play ${homeStyle.play}`}>
                                                        </i>
                                                    </div>
                                                    <h4 className={homeStyle.title}>{album.title}</h4>
                                                    <p className={homeStyle.artist}>{album.artist.name}</p>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </>
                                :
                                <div className={`${albums.length < 1 ? homeStyle.center : ""}`}>
                                    <div className={homeStyle.card}>
                                        <h2>Sorry, we couldn't find any result</h2>
                                        <SadFaceSVG className={homeStyle.notFound} />
                                    </div>
                                </div>
                        }
                    </LoadOverlay>
                </div>
            </Layout>
        </>
    )
}